
import React from 'react'
import useWindowSize from 'react-use-window-size'
import Confetti from 'react-confetti'

export default function Defult () {
    const { width, height } = useWindowSize()
    return (
        <Confetti
            width={width}
            height={height}
        />
    )
}